module.exports = __webpack_public_path__ + "launcher/fonts/perfectlyNineties/PerfectlyNineties-Bold.otf";